import { HeaderProps } from "./types";
import React from "react";
import { useNavigation } from "@react-navigation/native";

export const Header = ({
  isOpen,
  username,
  avatar,
}: HeaderProps): React.ReactElement => {
  const navigation = useNavigation();

  return (
    <section>
      <div className="flex-column flex justify-center">
        <button
          className="text-center"
          onClick={() => navigation.navigate("profile")}
        >
          {avatar !== "" ? (
            <img
              src={avatar}
              className="mx-auto h-12 w-12 rounded-full object-cover object-center"
              alt="img"
            />
          ) : (
            <section className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-[#147efb] text-2xl font-bold text-white">
              <span>{username.length > 0 ? username[0] : ""}</span>
            </section>
          )}
        </button>
      </div>
      <p
        className={`mt-1 truncate px-4 text-center text-tiny text-white ${
          isOpen ? "visible" : "invisible"
        }`}
      >
        {username}
      </p>
      <section className="mt-3 h-[1px] bg-white" />
    </section>
  );
};
